import Cookie from 'js-cookie';
import { MAX_RESULT, POS_ANNOUNCEMENT_COOKIE, POS_ANNOUNCEMENT_COOKIE_EXPIRATION, POS_REQUEST_MAX_ITEMS } from '../settings/pointOfSale';
import { getAnnouncement, getFilters, getPointsOfSale, getSearchResults } from '../services/pointOfSale';

export const RECEIVE_POINTS_OF_SALE = 'RECEIVE_POINTS_OF_SALE';
export const POS_NOT_LOADED = 0;
export const POS_LOADING = 1;
export const POS_LOADED = 2;
let posLoadState = POS_NOT_LOADED;
export function fetchPointsOfSale(dispatch) {
  if (posLoadState === POS_NOT_LOADED) {
    posLoadState = POS_LOADING;
    getPointsOfSale()
      .then(json => dispatch({
        type: RECEIVE_POINTS_OF_SALE,
        data: json
      }))
      .then(() => posLoadState = POS_LOADED);
  }
}

export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export function fetchSearchResults(dispatch, ids) {
  if (ids.length > MAX_RESULT) {
    console.error(`Fetching too many items (asked=${ids.length}, max=${MAX_RESULT}) : Aborting...`);
    return;
  }

  dispatch({ type: FETCH_SEARCH_RESULTS });

  const requestIds = [];
  while (ids.length > 0) {
    requestIds.push(ids.splice(0, POS_REQUEST_MAX_ITEMS));
  }

  const promises = requestIds
    .map(ids =>
      getSearchResults(ids).catch(error => {
        console.error(error);
        return {Count: 0, Items: []};
      })
    );

  return Promise
    .all(promises)
    .then(jsons => dispatch({
      type: RECEIVE_SEARCH_RESULTS,
      data: jsons.reduce((prev, json) => {
        prev.Count += json.Count;
        prev.Items = prev.Items.concat(json.Items);
        return prev;
      }, {Count: 0, Items: []})
    }));
}

export const RECEIVE_FILTERS = 'RECEIVE_FILTERS';
export const FILTERS_NOT_LOADED = 0;
export const FILTERS_LOADING = 1;
export const FILTERS_LOADED = 2;
let filtersLoadState = FILTERS_NOT_LOADED;
export function fetchFilters(dispatch) {
  if (filtersLoadState === FILTERS_NOT_LOADED) {
    filtersLoadState = FILTERS_LOADING;
    getFilters()
      .then(json => dispatch({
        type: RECEIVE_FILTERS,
        data: json
      }))
      .then(() => filtersLoadState = FILTERS_LOADED);
  }
}

export const SELECT_POINTS_OF_SALE = 'SELECT_POINTS_OF_SALE';
export function selectPointOfSale(dispatch, id) {
  dispatch({
    type: SELECT_POINTS_OF_SALE,
    data: id
  });
}

export const CLOSE_MOBILE_SHOP = 'CLOSE_MOBILE_SHOP';
export function unselectPointOfSale(dispatch, id) {
  dispatch({
    type: CLOSE_MOBILE_SHOP,
    data: id
  });
}

export const MAP_IS_READY = 'MAP_IS_READY';
export function mapIsReady(dispatch, map) {
  dispatch({
    type: MAP_IS_READY,
    map
  });
}

export const MARKERS_UPDATED = 'MARKERS_UPDATED';
export function updateMarkersInBounds(dispatch, markers, zoom, bounds) {
  dispatch({
    bounds,
    type: MARKERS_UPDATED,
    markers,
    zoom
  });
}

export const VISIBLE_MARKERS_UPDATED = 'VISIBLE_MARKERS_UPDATED';
export function updateVisibleMarkers(dispatch, markers) {
  dispatch({
    type: VISIBLE_MARKERS_UPDATED,
    markers
  });
}

export const TOGGLE_ITINERARY = 'TOGGLE_ITINERARY';
export function toggleItinerary(dispatch, id, state) {
  dispatch({
    type: TOGGLE_ITINERARY,
    id,
    state
  });
}

export const CHANGE_TRAVEL_MODE = 'CHANGE_TRAVEL_MODE';
export function changeTravelMode(dispatch, mode) {
  dispatch({
    type: CHANGE_TRAVEL_MODE,
    data: mode
  });
}

export const SET_CURRENT_ADDRESS = 'SET_CURRENT_ADDRESS';
export function setCurrentAddress(dispatch, address) {
  dispatch({
    type: SET_CURRENT_ADDRESS,
    data: address
  });
}

export const FETCH_ITINERARY = 'FETCH_ITINERARY';
export function fetchItinerary(dispatch, itinerary) {
  dispatch({
    type: FETCH_ITINERARY,
    data: itinerary
  });
}

export const SEARCH = 'SEARCH';
export function search(dispatch, viewport, position = null, userAction = false) {
  dispatch({
    type: SEARCH,
    viewport,
    position,
    userAction
  });
}

export const OPEN_ITINERARY_DETAILS = 'OPEN_ITINERARY_DETAILS';
export function openItineraryDetails(dispatch) {
  dispatch({type: OPEN_ITINERARY_DETAILS});
}

export const CLOSE_ITINERARY_DETAILS = 'CLOSE_ITINERARY_DETAILS';
export function closeItineraryDetails(dispatch) {
  dispatch({type: CLOSE_ITINERARY_DETAILS});
}

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export function updateFilters(dispatch, filters) {
  dispatch({
    type: UPDATE_FILTERS,
    data: filters
  });
}

export const TOGGLE_CATEGORY_FILTER = 'TOGGLE_CATEGORY_FILTER';
export function toggleFilterCategory(dispatch, index) {
  dispatch({
    type: TOGGLE_CATEGORY_FILTER,
    data: index
  });
}

export const RECEIVE_ANNOUNCEMENT = 'RECEIVE_ANNOUNCEMENT';
export const ANNOUCEMENT_NOT_LOADED = 0;
export const ANNOUCEMENT_LOADING = 1;
export const ANNOUCEMENT_LOADED = 2;
let announcementLoadState = ANNOUCEMENT_NOT_LOADED;
export function fetchAnnouncement(dispatch) {
  if (announcementLoadState === ANNOUCEMENT_NOT_LOADED) {
    announcementLoadState = ANNOUCEMENT_LOADING;
    getAnnouncement()
      .then(json => {
        if (json.announcement && (Cookie.get(POS_ANNOUNCEMENT_COOKIE) !== json.announcement.id)) {
          dispatch({
            type: RECEIVE_ANNOUNCEMENT,
            data: json
          })
        }
      })
      .then(() => announcementLoadState = ANNOUCEMENT_LOADED);
  }
}

export const CLOSE_ANNOUNCEMENT = 'CLOSE_ANNOUNCEMENT';
export function closeAnnoucement(dispatch, id) {
  Cookie.set(POS_ANNOUNCEMENT_COOKIE, id, {expires: POS_ANNOUNCEMENT_COOKIE_EXPIRATION});
  dispatch({type: CLOSE_ANNOUNCEMENT})
}

export const SELECT_POS_AND_CLOSE_ANNOUNCEMENT = 'SELECT_POS_AND_CLOSE_ANNOUNCEMENT';
export function loadPointOfSale(dispatch, annoucementId, posId) {
  Cookie.set(POS_ANNOUNCEMENT_COOKIE, annoucementId, {expires: POS_ANNOUNCEMENT_COOKIE_EXPIRATION});
  dispatch({
    type: SELECT_POS_AND_CLOSE_ANNOUNCEMENT,
    data: posId
  });
}

export const MAP_SCRIPT_LOADED = 'MAP_SCRIPT_LOADED';
export function mapScriptLoaded(dispatch, api) {
  dispatch({
    type: MAP_SCRIPT_LOADED,
    api
  });
}

export const SET_PANEL = 'SET_PANEL';
export function setPanel(dispatch, panel) {
  dispatch({
    type: SET_PANEL,
    panel
  });
}

export const ZOOM_CHANGED = 'ZOOM_CHANGED';
export function zoomChanged(dispatch, zoom) {
  dispatch({
    type: ZOOM_CHANGED,
    zoom
  });
}


// WEBPACK FOOTER //
// ./src/actions/pointOfSale.js